// extracted by mini-css-extract-plugin
module.exports = {"container":"Form_container__1TGb4","form":"Form_form__1Z9U3"};